import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { getLists } from '@global/api'
import { IListColumn } from '../../types'

const KEY = 'getLists'

interface useListsQueryProps {
  options?: Omit<
    UseQueryOptions<IListColumn[], unknown, IListColumn[], string[]>,
    'queryKey' | 'queryFn'
  >
}

export const useListsQuery = ({ options }: useListsQueryProps) =>
  useQuery({
    queryKey: [KEY],
    queryFn: ({ signal }) => getLists({ signal }),
    ...options,
  })
